import api from '../../plugins/api';

// ÐÐ°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ (Freedom, Ð¿.4.1 ÑÑÐµÐ¼Ñ).
// ÐÐ±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐ¹ ÑÐ°Ð³ Ð¿ÐµÑÐµÐ´ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸ÐµÐ¼ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð´Ð»Ñ ÑÐ¸Ð¿Ð¾Ð² THRIFT*:
// Ð±Ð°Ð½Ðº ÑÐ²ÐµÑÑÐµÑ ÐÐÐ Ñ Ð±Ð°Ð·Ð¾Ð¹ ÐÐÐ Ð¿Ð¾ VIN Ð¸ ÑÐ»ÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÑ Ð¡ÐÐ¡ Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ñ.
const ffinAddOwner = ({ appealId, iin, mobilePhone }) => {
  return api.post('/api/bank/ffin/owner', { appealId, iin, mobilePhone });
};

export default ffinAddOwner;
